import { render } from "./SectionDropdown.vue?vue&type=template&id=53f3b477&scoped=true"
import script from "./SectionDropdown.vue?vue&type=script&lang=js"
export * from "./SectionDropdown.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SectionDropdown.vue?vue&type=style&index=0&id=53f3b477&lang=scss&module=true"
cssModules["$style"] = style0
import "./SectionDropdown.vue?vue&type=style&index=1&id=53f3b477&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-53f3b477"]])

export default __exports__